
import { defineComponent } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  name: "Home",
  setup() {
    const store = useStore();
    store.dispatch("updateLoading", false);
  },
});
